import { Grid, Table, TableBody, makeStyles } from "@material-ui/core";
import { IBillingDataItem } from "api/interfaces/megaERP";
import { PageLoading } from "components/UI/Page";
import { HeadTable, Row } from "components/UI/Table";
import { lang } from "i18nLang";
import { useEffect, useState } from "react";
import { sum } from "utils/DecimalPrecision";

const useStyles = makeStyles(() => ({
  container: {
    width: "100%",
    height: "inherit",
    display: "block",
    overflowY: "scroll",
  },
  loading: { padding: "3rem 0" },
  headCell: {
    height: 56,

    "& th": {
      color: "#757575",
      border: "none",
      position: "sticky",
      top: 0,
      backgroundColor: "white",
    },
  },
  tableBody: {
    "& tr:last-child > *": {
      border: "none",
      fontWeight: 500,
    },
  },
}));

/** Componente tabela para exibir um resumo dos itens enviados para
 * faturamento.
 */
const ResumeItems = ({
  rowsData,
  onCreate,
}: {
  /** Lista de itens do faturamento. */
  rowsData: IBillingDataItem[];
  /** Evento disparado ao criar o componente. */
  onCreate?: () => void;
}) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const columns = [
    { dataKey: "productName", label: lang("fields.item") },
    { dataKey: "cityName", label: lang("fields.city") },
    { dataKey: "apportionmentType", label: lang("fields.type") },
    {
      dataKey: "unitCost",
      label: lang("fields.apportionmentValue"),
      align: "right",
      monetary: true,
    },
  ];

  useEffect(() => {
    if (!onCreate) return;

    setLoading(true);
    setTimeout(() => {
      onCreate();
      setLoading(false);
    }, 200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <PageLoading className={classes.loading} />;

  const rows = rowsData.map((item) => ({
    ...item,
    apportionmentType: lang(
      `billing.apportionmentTypes.${item.apportionmentType}`
    ),
  }));
  const total = rows.reduce((acc, item) => sum(acc, item.unitCost), 0);
  rows.push({
    codItem: 0,
    description: "",
    pattern: 0,
    unit: { code: "", pattern: 1 },
    materialUsed: false,
    unitCost: total,
    discount: 0,
    retention: 0,
    productName: lang("fields.total"),
    cityName: "",
    apportionmentType: "",
  });

  return (
    <Grid className={classes.container}>
      <Table>
        <HeadTable
          className={classes.headCell}
          columns={columns}
          fontWeight={500}
        />
        <TableBody className={classes.tableBody}>
          {rows.map((row, index) => (
            <Row key={index} columns={columns} row={row} />
          ))}
        </TableBody>
      </Table>
    </Grid>
  );
};

export default ResumeItems;
